/**
 * Plano de 07/10/2026 (menus Aplicabilidades e Tabelas de Preços, Frente 1) — decisão do TI CEM de
 * 07/10 14:23: "Aplicabilidade e Tabela de Preços ficam visíveis para o usuário logado se a empresa
 * possuir acesso e liberar a utilização do recurso para este usuário" (P1 decidida em 08/10).
 *
 * Três fatores, o mesmo padrão de Produtos/Tipologias/Tarefas:
 *  1. a empresa tem a aba (no perfil ou como recurso adicional);
 *  2. o usuário tem a aba;
 *  3. o token traz ao menos uma tela do recurso — essas telas só existem quando a empresa CONFIGUROU
 *     o recurso em Gerência > Empresa (referências de Aplicabilidades / Tabela de Preços).
 * Exportacao, Configuracao e Master sozinhos NÃO liberam nenhum dos dois menus.
 */

export const ABA_APLICABILIDADES = 3;
export const ABA_TABELAS_PRECO = 4;

export const TELAS_APLICABILIDADE = [
  "AplicabilidadeComponente",
  "AplicabilidadeComponenteBase",
  "AplicabilidadeApontamentoProprio",
];

export const TELAS_TABELA_PRECO = [
  "TabelasPreco",
  "TabelasPrecoComponentes",
  "TabelasPrecoVidros",
  "TabelasPrecoPerfis",
  "TabelasPrecoAcabamentos",
  "TabelasPrecoKits",
  "TabelasPrecoSuperficies",
];

interface IAbaComId {
  id: number;
}

/** A empresa tem a aba no perfil OU como recurso adicional. */
export const empresaTemRecurso = (
  abasPerfil: IAbaComId[] | null | undefined,
  recursosAdicionais: IAbaComId[] | null | undefined,
  idAba: number
): boolean =>
  (abasPerfil ?? []).some((aba) => aba?.id === idAba) ||
  (recursosAdicionais ?? []).some((recurso) => recurso?.id === idAba);

/** O usuário tem a aba liberada (abasUtilizadas de MinhaEmpresa/ObterMeuUsuario). */
export const usuarioTemAba = (
  abasUsuario: IAbaComId[] | null | undefined,
  idAba: number
): boolean => (abasUsuario ?? []).some((aba) => aba?.id === idAba);

/** Regra completa: recurso da empresa E aba do usuário E tela do recurso no token. */
export const temAcessoRecurso = (
  empresaTemORecurso: boolean,
  usuarioTemAAba: boolean,
  havePermission: (permissoes: string[]) => boolean,
  telasDoRecurso: string[]
): boolean => empresaTemORecurso && usuarioTemAAba && havePermission(telasDoRecurso);
